import type { FaireProductEntity } from "../../entity_types/product";

export const p_gmj8tudb62: FaireProductEntity = {
  token: "p_gmj8tudb62",
  type: "product",
  name: "C.C Baby Knit Double Pom Pom Beanie",
  brandToken: "b_926lzrw9gt",
  brandName: "Hana",
  imageUrl:
    "https://cdn.faire.com/fastly/da70e6cc5b2406ba4eab89b9b44bb80e2d8e4fe35d8798afab4aaa69a0ef6fa4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/344389e55fbf5934abc5e7b56a8d1bd075cf0980b5bbbf49a84b776db8250e7e.jpeg",
    "https://cdn.faire.com/fastly/8320f5bacdc0f71a4c7ac2ff1b0885a93c87a5f186740e9d8fe790e5cc6285ab.jpeg",
    "https://cdn.faire.com/fastly/ea37720f1c7dc7ca5265da7892ee9ea6826069b683b744398bf9dd1e71f79dfc.jpeg",
    "https://cdn.faire.com/fastly/47808d68c564852855886271bf1c4b79ab399f4dd78b10fad1ba912509cbeb66.jpeg",
    "https://cdn.faire.com/fastly/9562394ac9ed15ebd707f89044e7c9f0b329f50617d06480343f8b66f8037ff3.jpeg",
    "https://cdn.faire.com/fastly/d8a236bea9b4fe13f7812f7f09c650310ff9c3d2c600d82b06feda4dad5d04f6.jpeg",
    "https://cdn.faire.com/fastly/15c88590666a2504fc4a073f052b06b6524a645e34ec6bd31696939410061786.jpeg",
    "https://cdn.faire.com/fastly/4380b51b3fd4c9b40edd3fa4784b06108c1207b0072b87a9dbe71580c8f23030.jpeg",
    "https://cdn.faire.com/fastly/ef89ec232d4aa0bbfc5d13b16982888c91ce3217cf5642fbe4ea070b3cf1d2c0.jpeg",
    "https://cdn.faire.com/fastly/71c0011a42beb6e53df3a4b1d95e48848ec9971e740e0fbea3d53a23bbfa41dc.jpeg",
    "https://cdn.faire.com/fastly/24fb99866a70a8b714692632cf192863e3f93efffd6ee7825bfd69d603b2e7cd.jpeg",
  ],
  priceDollars: 11.09,
  description: "C.C Baby knit beanie with double pom pom\n100% Acrylic",
  tags: [],
  msrpDollars: 22.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:10.610Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
